(function($) {
	$.fn.tagsHandler = function(options) {
		options = $.extend({
			tags: '.tags__list',
		}, options);

		var helpers = {
			getConnectedField: function($link) {
				var $connected_field = $('[id^="' + $link.data('field') + '"]').eq(0);

				if(!$connected_field.length) {
					$connected_field = $('[id^="' + $link.data('field').split('__')[0] + '"]').eq(0);
				}

				if(!$connected_field.length) {
					var search = $link.data('field').indexOf('filter_1') > -1 ? 'filter_1' : 'filter_0',
						replace = search === 'filter_0' ? 'filter_1' : 'filter_0';
					$connected_field = $('[id^="' + $link.data('field').replace(search, replace) + '"]').eq(0);

					if(!$connected_field.length) {
						console.log('[id^="' + $link.data('field').replace(search, replace).split('__')[0] + '"]');
						$connected_field = $(
							'[id^="' + $link.data('field').replace(search, replace).split('__')[0] + '"]'
						).eq(0);
					}
				}

				return $connected_field;
			},
			getTag: function($link) {
				return $link.closest('.tags__item');
			},
			removeTag: function($tag) {
				$tag.fadeOut(function() {
					$(this).remove();
				});
			},
			toggleConnectedField: function($connected_field, $tag, $link) {
				switch($connected_field.prop('type')) {
					case 'radio':
					case 'checkbox':
						$connected_field.each(function() {
							$(this).attr('checked', false).change();
						});
						break;
					default:
						if($connected_field.is('select')) {
							$($connected_field.get(0).selectedOptions).map(function() {
								if(this.text === $tag.text().replace($link.text(), '').trim()) {
									$('#' + $connected_field.attr('id')).data('multiselect').deselect(this.value);
								}
							});
							$connected_field.change();
						}
						else {
							$connected_field.each(function() {
								$(this).val('').change().click();
							});
						}
				}
			}
		};

		return this.each(function() {
			$(this).on({
				click: function(e) {
					var $link = $(this),
						$tag = helpers.getTag($link),
						$connected_field = helpers.getConnectedField($link, $tag);

					helpers.removeTag($tag);
					helpers.toggleConnectedField($connected_field, $tag, $link);

					return false;
				},
			}, options.tags + ' a[data-field]'
			);
		});
	}
})(jQuery);